import { CalendarProvider } from "./CalendarContext";
import Calendar from "./Calendar";
import AppointmentFilter from "./AppointmentFilter";
import { Card, Grid } from "antd";
import { t } from "i18next";
import AppointmentMenu from "./AppointmentMenu";
import SimpleLayout from "../../../core/components/layout/SimpleLayout";
import { useEffect } from "react";

export default function CalendarApp() {
    const screens = Grid.useBreakpoint();
    const isNarrow = !screens.md;   // < 768px

    useEffect(() => {
        document.title = `HIS - ${t('Calendar')}`
    }, []);

    return (
        <>
            {/* Takvim dar ekranda her pikseli kullanmalı: layout'un yan/alt boşlukları, Card'ın gövde
                padding'i, çerçevesi ve köşe yarıçapı mobilde kaldırılır; içerik ekrana yapışır.
                Üst boşluk KALIR — mobil header sabit konumlu, sıfırlarsak takvim altına girer. */}
            <SimpleLayout fullWidth={true} flushOnMobile={true}>
                <Card
                    bordered={!isNarrow}
                    style={isNarrow ? { borderRadius: 0 } : undefined}
                    styles={{ body: { padding: isNarrow ? 0 : undefined } }}
                >
                    <CalendarProvider>
                        {/* Takvimin kendisi tam genişlikte kalır; sadece üstteki filtre/menü
                            şeridi mobilde kenara yapışmasın diye küçük bir iç boşluk alır. */}
                        <div style={isNarrow ? { padding: '8px 8px 0' } : undefined}>
                            <AppointmentFilter />
                            <AppointmentMenu />
                        </div>
                        {/* Mobilde takvimle toolbar arası dar tutulur (fazla boşluk olmasın);
                            masaüstünde eski satır boşluğu korunur. */}
                        {isNarrow ? <div style={{ height: 6 }} /> : <br />}
                        <Calendar />
                    </CalendarProvider>
                </Card>
            </SimpleLayout>
        </>
    )
}
